import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { deleteSysOperationRecord as _deleteSysOperationRecord, getSysOperationRecordList, deleteSysOperationRecordByIds } from '@/api/sysOperationRecord'; // 此处请自行替换地址
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
export default {
  name: 'SysOperationRecord',
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool !== null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysOperationRecordList,
      dialogFormVisible: false,
      type: '',
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        ip: null,
        method: null,
        path: null,
        status: null,
        latency: null,
        agent: null,
        error_message: null,
        user_id: null
      }
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDelete: function onDelete() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ids, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              _this.multipleSelection && _this.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 1;
              return deleteSysOperationRecordByIds({
                ids: ids
              });
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                _this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                if (_this.tableData.length === ids.length && _this.page > 1) {
                  _this.page--;
                }
                _this.deleteVisible = false;
                _this.getTableData();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteSysOperationRecord: function deleteSysOperationRecord(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 1;
              return _deleteSysOperationRecord({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: '删除成功'
                });
                if (_this2.tableData.length === 1 && _this2.page > 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fmtBody: function fmtBody(value) {
      try {
        return JSON.parse(value);
      } catch (err) {
        return value;
      }
    }
  }
};